<div class="modal-header">
    <div class="modal-title">{{ ctx().fileName || 'Preview' }}</div>
    <button
        type="button"
        class="btn btn-close btn-sm"
        aria-label="Close"
        (click)="close()"
    ></button>
</div>

<div class="modal-body">
    @if (comp()) {
        <ng-container>
            <ng-container
                *ngComponentOutlet="comp(); inputs: { context: ctx() }"
            ></ng-container>
        </ng-container>
    }
</div>
